import React from "react";
import { CommonLoader } from "../../../common/CommonLoader";
import { formatAmount } from "../../../../services/utils";
import {
  EnterOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { Button } from "antd";
import _ from 'i18n';

const CotisantStats = ({
  categories,
  fetchingNbrCotisantByFormat,
  formattedCAData,
  frequency,
  year,
  month,
  associativeMembership,
  fetchingMembershipAssociative,
  visibleKeys,
  onToggleKey,
  showCompareStatsForAppType,
  showCompareAppTypeStatsArray,
  showCompareStatsForAllAppType,
  compareAll,
  showCompareAppTypeStats,
  showCompareStats
}) => {

  const formatCotisationText = (period) => {
    const [year, month] = period.split('-').map(Number);
    const monthPadded = month.toString().padStart(2, '0'); // Ensure two digits
    const lastDay = new Date(year, month, 0).getDate(); // Get last day of the month

    return `Les cotisations effectuées du 01/${monthPadded} au ${lastDay}/${monthPadded}`;
  }

  // Calculate totals
  const totalNbrInscription = categories.reduce((sum, category) => sum + category.total, 0);
  const totalCA = formattedCAData.categories.reduce((sum, category) => sum + category.total, 0);

  return (
    <div style={{
      background: "#F9FAFB",
      padding: "20px",
      borderRadius: "10px",
      width: "40%",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
    }}>
      {
        fetchingNbrCotisantByFormat || fetchingMembershipAssociative
          ?
          <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
          :
          <React.Fragment>
            <div style={{ display: "flex", justifyContent: "center", padding: "4px 0", fontSize: "14px", color: "#29394D" }}>
              {frequency === 'MONTHLY' && <h4 style={{ fontWeight: "600", color: "#29394D" }}>Les cotisations effectuées dans l’année {year[0]}</h4>}
              {frequency === 'DAILY' && <h4 style={{ fontWeight: "600", color: "#29394D" }}>{formatCotisationText(month)}</h4>}
              {frequency === 'YEARLY' && <h4 style={{ fontWeight: "600", color: "#29394D" }}>Le total des cotisations effectuées</h4>}
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D" }}>
              <span style={{ width: '35%' }}></span>
              <span style={{ width: '30%', textAlign: 'end' }}>Cotisation</span>
              <span style={{ width: '30%', textAlign: 'end' }}>C.A</span>
              <span style={{ width: '5%' }}></span>
            </div>

            {categories.map((category, index) => (
              <div key={index} style={{ marginTop: "15px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", width: showCompareStats === false && frequency === 'DAILY' ? '25%' : '35%' }}>
                    <span style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "40%",
                      backgroundColor: category.color
                    }}></span>
                    <span style={{ fontWeight: "500", fontSize: "16px", color: "#29394D" }}>{category.name}</span>
                  </div>
                  {
                    showCompareStats === false && frequency === 'DAILY' &&
                    <div style={{ width: '20%', textAlign: 'end' }}>
                      <Button
                        type="primary"
                        onClick={() => showCompareStatsForAppType(category.name)}
                        disabled={false}
                        style={{ width: '100%' }}
                        className={"compare-button " + (showCompareAppTypeStatsArray[category.name] ? 'active-button' : '')}
                      >
                        {_('COMPARE')}
                      </Button>
                    </div>
                  }
                  <span style={{ fontWeight: "500", color: category.color, width: showCompareStats === false && frequency === 'DAILY' ? '20%' : '30%', textAlign: 'end' }}>{category.name == 'Fiduciaire' ? (category.total + (categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0)) : (category.total - (categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0))}</span>
                  <span style={{ fontWeight: "500", color: category.color, width: '30%', textAlign: 'end' }}>{formatAmount(formattedCAData.categories[index].total)}</span>
                  <span style={showCompareAppTypeStats === false ? {
                    fontWeight: "700",
                    width: '5%',
                    fontSize: "18px",
                    textAlign: 'end',
                    cursor: 'pointer',
                    backgroundColor: '#F1F2F4',
                    borderRadius: '50%',
                    height: '26px',
                    width: '26px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  } : {
                    fontWeight: "700",
                    width: '5%',
                    fontSize: "18px",
                  }} onClick={() => {
                    onToggleKey(category.name);
                  }}>
                    {showCompareAppTypeStats === false && category.name === 'Fiduciaire' ? (<img src={visibleKeys.includes('Fiduciaire') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />) : null}
                    {showCompareAppTypeStats === false && category.name === 'Statutaire' ? (<img src={visibleKeys.includes('Statutaire') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />) : null}
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", width: '35%' }}>
                    <span style={{ fontWeight: "500", fontSize: "14px", color: "#29394D" }}>Prix moyen par achat</span>
                  </div>
                  <span style={{ fontWeight: "500", color: category.color, width: '60%', textAlign: 'end' }}>
                    {category.name == 'Fiduciaire'
                      ? formatAmount(formattedCAData.categories[index].total === 0 ? 0 : formattedCAData.categories[index].total / (category.total + (categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0)))
                      : formatAmount(formattedCAData.categories[index].total === 0 ? 0 : formattedCAData.categories[index].total / (category.total - (categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0)))
                    }
                  </span>
                  <span style={{
                    fontWeight: "700",
                    width: '5%',
                    fontSize: "18px",
                  }}></span>
                </div>

                {/* Subcategories */}
                <div style={{ borderTop: "1px solid #D1D5DB", marginTop: "8px", paddingTop: "8px" }}>
                  {
                    category.name == 'Fiduciaire'
                      ?
                      category.subCategories.map((sub, idx) => (
                        <React.Fragment key={idx} style={{}}>
                          <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                            <span style={{ width: '35%' }}>{sub.name}</span>
                          </div>
                          <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                            <span style={{ width: '35%', paddingLeft: '10px' }}>{'Membres Non Associés'}</span>
                            <span style={{ width: '30%', textAlign: 'end' }}>{sub.count}</span>
                            <span style={{ width: '30%', textAlign: 'end' }}>{formattedCAData.categories[index].subCategories[idx] ? formatAmount(formattedCAData.categories[index].subCategories[idx].count) : formatAmount(0)}</span>
                            <span style={{ width: '5%' }}></span>
                          </div>
                        </React.Fragment>
                      ))
                      :
                      category.subCategories.slice(0, -1).map((sub, idx) => (
                        <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                          <span style={{ width: '35%' }}>{sub.name}</span>
                          <span style={{ width: '30%', textAlign: 'end' }}>{sub.count}</span>
                          <span style={{ width: '30%', textAlign: 'end' }}>{formattedCAData.categories[index].subCategories[idx] ? formatAmount(formattedCAData.categories[index].subCategories[idx].count) : formatAmount(0)}</span>
                          <span style={{ width: '5%' }}></span>
                        </div>
                      ))}
                </div>
              </div>
            ))}
            <div style={{ opacity: visibleKeys.includes('Fiduciaire') ? 1 : 0.5 }}>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D" }}>
                <span style={{ width: '35%', paddingLeft: '10px' }}>{'Membres Associés'}</span>
                <span style={{ width: '30%', textAlign: 'end' }}>{categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0}</span>
                <span style={{ width: '30%', textAlign: 'end' }}>{formatAmount(0)}</span>
                <span style={{ width: '5%' }}></span>
              </div>
            </div>

            {/* Totals Row */}
            <div style={{ borderTop: "2px solid #29394D", marginTop: "15px", paddingTop: "10px", fontWeight: "600", color: "#29394D", display: "flex", justifyContent: "space-between", alignItems: 'center', fontSize: "16px" }}>
              <span style={{ width: showCompareStats === false && frequency === 'DAILY' ? '25%' : '35%' }}>Total</span>
              {
                showCompareStats === false && frequency === 'DAILY' &&
                <div style={{ width: '20%' }}>
                  <Button
                    type="primary"
                    // disabled={fetching} 
                    onClick={() => showCompareStatsForAllAppType(compareAll)}
                    style={{ width: '100%', padding: 0, fontSize: '75%' }}
                    className={"compare-button " + (compareAll ? 'active-button' : '')}
                  >
                    {'Comparer tous'}
                  </Button>
                </div>
              }
              <span style={{ width: showCompareStats === false && frequency === 'DAILY' ? '20%' : '30%', textAlign: 'end' }}>{totalNbrInscription}</span>
              <span style={{ width: '30%', textAlign: 'end' }}>{formatAmount(totalCA)}</span>
              <span style={{ width: '5%' }}></span>
            </div>
            <div style={{ fontWeight: "500", color: "#29394D", display: "flex", justifyContent: "space-between", alignItems: 'center', fontSize: "14px" }}>
              <span style={{ width: '35%' }}>Prix moyen par achat</span>
              <span style={{ width: '60%', textAlign: 'end' }}>{formatAmount(totalCA === 0 ? 0 : totalCA / totalNbrInscription)}</span>
              <span style={{ width: '5%' }}></span>
            </div>
            <div style={{ fontWeight: "500", color: "#29394D", display: "flex", justifyContent: "space-between", alignItems: 'center', fontSize: "14px" }}>
              <span style={{width: '35%'}}>Prix moyen par achat</span>
              <span style={{width: '60%', textAlign: 'end'}}>{formatAmount(totalCA === 0 ? 0 : totalCA / totalNbrInscription)}</span>
              <span style={{width: '5%'}}></span>
            </div>
          </React.Fragment>
      }
    </div>
  );
};

export default CotisantStats;


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CotisantStats.js